import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import FilterRequestTypePopover from "./filter-request-type-popover";

class FilterRequestType extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.handleClosePopover = this.handleClosePopover.bind(this);
    this.onOpenPopover = this.onOpenPopover.bind(this);
  }

  onOpenPopover() {
    this.setState({ show: !this.state.show });
  }

  handleClosePopover() {
    this.setState({ show: false });
  }

  render() {
    const {
      requestTypes,
      selectedRequestType,
      handleRequestTypeFilterChanged,
    } = this.props;

    let selectorText = "";

    if (selectedRequestType === -1) {
      selectorText = <b>All request types</b>;
    } else if (_.isArray(selectedRequestType)) {
      selectorText = (
        <span>
          Request Type({selectedRequestType.length}):{" "}
          <b style={{ marginRight: "4px" }}>{selectedRequestType.join(", ")}</b>
        </span>
      );
    }

    return (
      <React.Fragment>
        <OverlayTrigger
          rootClose={true} // close when clicked outside overlay
          show={this.state.show}
          onToggle={this.onOpenPopover}
          trigger="click"
          placement="bottom-start"
          overlay={
            <Popover
              id="request-type-selector-popover"
              // title="Select Network"
              className="shadow-lg p-2"
              style={{
                maxWidth: "600px",
                width: "600px",
                backgroundColor: "#f7f7f7",
              }}
            >
              <FilterRequestTypePopover
                requestTypes={requestTypes}
                selectedRequestType={selectedRequestType}
                handleRequestTypeFilterChanged={handleRequestTypeFilterChanged}
                handleClosePopover={this.handleClosePopover}
              ></FilterRequestTypePopover>
            </Popover>
          }
        >
          <Button
            variant="light"
            style={styles.filterBtn}
            className="text-dark px-3 d-flex align-items-center"
          >
            <div className="text-truncate" style={styles.filterText}>
              {selectorText}
            </div>
            <span className="fa fa-angle-down ml-2"></span>
          </Button>
        </OverlayTrigger>
      </React.Fragment>
    );
  }
}

const styles = {
  header: {
    padding: "12px 84px",
  },
  filterBtn: {
    border: "1px solid lightgray",
  },
  filterText: {
    maxWidth: "220px",
  },
};

export default FilterRequestType;
